import { LuCircleAlert, LuClipboardCheck, LuWrench } from 'react-icons/lu';
export var EventType;
(function (EventType) {
    EventType["PeriodicInspection"] = "periodic";
    EventType["EmergencyInspection"] = "emergency";
    EventType["RepairConstruction"] = "repair";
    EventType["FollowUpInspection"] = "follow_up";
})(EventType || (EventType = {}));
export const EventTypeOptions = Object.freeze(Object.values(EventType));
export var InspectionStatus;
(function (InspectionStatus) {
    InspectionStatus["Draft"] = "draft";
    InspectionStatus["InProgress"] = "in_progress";
    InspectionStatus["Completed"] = "completed";
    InspectionStatus["Submitted"] = "submitted";
})(InspectionStatus || (InspectionStatus = {}));
export const InspectionStatusOptions = Object.freeze(Object.values(InspectionStatus));
export const EventStylesConfig = {
    [EventType.PeriodicInspection]: { icon: LuClipboardCheck, color: 'green' },
    [EventType.FollowUpInspection]: { icon: LuClipboardCheck, color: 'blue' },
    [EventType.EmergencyInspection]: { icon: LuCircleAlert, color: 'red' },
    [EventType.RepairConstruction]: { icon: LuWrench, color: 'orange' },
};
